import { defineComponent as t, createElementBlock as o, openBlock as n, normalizeProps as a, guardReactiveProps as c, unref as s, renderSlot as l } from "vue";
import { useBindCx as f } from "@scalar/use-hooks/useBindCx";
const i = {}, m = /* @__PURE__ */ t({
  ...i,
  inheritAttrs: !1,
  __name: "ScalarCardSection",
  setup(_) {
    const { cx: e } = f();
    return (r, d) => (n(), o("div", a(c(s(e)("scalar-card-content flex overflow-auto"))), [
      l(r.$slots, "default")
    ], 16));
  }
});
export {
  m as default
};
